import type { CasesCopy } from '../content'

export const zh: CasesCopy = {
  note: '根据保密协议，客户名称与真实数据均已隐去。界面为本网站重新绘制，其中数值仅作示意。',
  labels: { before: '之前', after: '之后', results: '客户获得了什么', modules: '模块' },
  flagship: {
    id: 'platform',
    sector: '电子元器件分销 · 国际贸易',
    title: '分销商的数字化平台：从客户询价到报关——再到通过 AI 智能体销售',
    lead: '为一家国际电子元器件分销商打造的一体化系统：覆盖各部门的 ERP 与 CRM、面向客户的 B2B 门户、实时更新的商品目录、AI 搜索，以及直接从买家 AI 助手下单。每个模块都由我们自主设计、开发并持续迭代。',
    before: '靠电话和表格采购，文件通过邮件往来，交期全凭手算，每个环节都可能出错。',
    after: '从寻找供应商到仓库收货全程自动化：每个订单的每一步都清晰可见，买家可以自行查找和订购元器件——在网站上，或通过自己的 AI 智能体。',
    metrics: [
      { value: '约 800 万', label: '目录商品' },
      { value: '15+', label: '全球分销商一次搜索' },
      { value: '×17', label: '目录页面打开速度提升' },
      { value: '约 1 分钟', label: '从 AI 助手提出需求到收到发票' },
    ],
    modules: [
      {
        id: 'erp',
        tab: 'ERP 与 CRM',
        title: '企业的运营核心',
        lead: '整条交易链集中在一个系统中——从客户询价到结算单据。每天有 100 多人在其中工作：管理层、销售、采购、物流、工程师、仓库和配送员。',
        points: [
          '采购：价格、许可证、认证与交期',
          '付款：按供应商所在国税务规则管控付款，支持分期与预付，合同与发票集中管理',
          '物流：发货、中转仓集货、承运商追踪与入库',
          '报关：报关员流程自动化，单据提交、许可证与证书管理',
          '与财务、WMS、CRM 和承运商系统集成——数据无需重复录入',
        ],
      },
      {
        id: 'portal',
        tab: 'B2B 门户',
        title: '客户自助服务',
        lead: '客户自行查找元器件、比较报价并下单——无需与销售经理反复沟通。',
        points: [
          '15 家以上全球分销商的报价集中在一张表中',
          '按料号搜索并实时比价——含阶梯价、最小起订量和包装倍数',
          '自动标出最优报价，几次点击即可下单',
          '全程追踪物流',
        ],
      },
      {
        id: 'catalog',
        tab: '商品目录',
        title: '约 800 万商品的实时目录',
        lead: '所有服务的基础：人、搜索引擎和 AI 智能体都能读懂的标准化数据。',
        points: [
          '约 800 万商品、约 940 个类目、约 4,700 家制造商，约 8,000 万条解析后的技术参数',
          '智能搜索：输入“功率电感”，即打开对应类目并自动设置好筛选条件',
          '商品页：清晰的描述、数据手册、市场价格与库存、3 个月价格走势、需求热度及按参数匹配的替代料',
          '每天根据客户搜索、工程师系统和供应商数据更新',
          '为搜索引擎收录而优化：易读的网址、几乎所有商品都有双语描述，带筛选的类目页约 1 秒打开（原先约 17 秒）',
        ],
      },
      {
        id: 'search',
        tab: 'AI 搜索',
        title: '任何形式的需求清单——变成现成订单',
        lead: '客户无需整理数据：系统能理解输入的内容，并找到最优报价。',
        points: [
          '料号、参数描述和自由文本混合输入——每次搜索最多 100 行',
          '支持任意格式文件：表格、PDF、文档、照片和扫描件；表头和无关内容自动剔除，只留下有效条目',
          '“电阻 4.7 kΩ 0603 5%”即可转换为匹配的料号及供应商报价',
          '按关键参数匹配替代料，而不是看型号名称是否相似',
          '综合最小起订量、包装倍数和库存给出最优价格——直接加入购物车',
        ],
      },
      {
        id: 'agent',
        tab: 'AI 智能体 / MCP 服务器',
        title: '全新销售渠道：从客户的 AI 助手直接下单',
        lead: '我们通过 MCP 标准将商城接入 AI 智能体。任何支持 MCP 的 AI 智能体都能直接与商城交互：客户只需提出需求并确认，其余交给智能体完成。',
        points: [
          '输入：料号清单、参数描述或最多 50 行的物料清单（BOM）',
          '搜索 → 选型 → 下单 → 开票，约一分钟完成',
          '优化器综合最小起订量、包装倍数、库存和交期，组合出最划算的订单',
          '订单仅以客户公司名义创建，且必须经客户确认；发票直接发送到对话中',
        ],
      },
    ],
  },
  energy: [
    {
      id: 'grid',
      sector: '能源 · 电力网络',
      title: '基于 CIM 标准的电网数字模型',
      lead: '为一家电网企业打造的软件系统，属于国家基础设施数字化项目。系统为整个企业建立详细的数字模型——电网、设备、测量数据与现场作业——并保持实时更新：作业完成后，变化立即反映在系统中。',
      standard: 'CIM · IEC 61970-301 · IEC 61968-11',
      before: '工程师徒步巡线，数据记在笔记本和零散的表格里，图纸都是纸质的。每次电价审核前都要手工收集数据。',
      after: '电网、设备与作业统一在一个数字模型中，数据无法被篡改、删除或隐瞒。电价、检修和并网所需的数据几次点击即可导出。',
      metrics: [
        { value: '数倍', label: '降低作业计划的工作量' },
        { value: '1 个模型', label: '取代纸质图纸和零散表格' },
        { value: 'CIM', label: '电网模型与数据交换的国际标准' },
        { value: '∞', label: '工位数量——许可费用与之无关' },
      ],
      modules: [
        {
          id: 'grid-model',
          tab: '电网模型',
          title: '统一的电气连接图',
          lead: '电网拓扑模型是调度中心的基础，并可与现有调度系统集成。',
          points: [
            '与地理位置关联的交互式电网地图——支持 GIS 和在线地图',
            '按电压等级、电缆线路和架空线路分层显示',
            '支持导入 KML、GPX 的线路编辑器，以及带单线图的变电站编辑器',
            '与电气图关联的资产模型和基础数据——计算模型的基础',
            '通过标准 CIM 协议交换数据，降低与其他系统集成的成本',
          ],
        },
        {
          id: 'grid-asset',
          tab: '资产档案',
          title: '每个电网资产都有完整档案',
          lead: '每根杆塔、每条线路、每座变电站和每台设备的技术参数、照片、测量数据和作业历史都保存在系统中。',
          points: [
            '设备在地图上直观可见：作业班组凭调度名称即可在现场轻松找到目标',
            '带照片的杆塔档案：材质、用途、结构及所属线路',
            '作业历史、测量数据和档案都保存在系统中，永不丢失',
            '数据来自所有相关部门，责任人可以立即查看',
          ],
        },
        {
          id: 'grid-monitor',
          tab: '状态监测',
          title: '设备状态与检修优先级',
          lead: '测量模型与电网模型、资产模型相互关联：系统掌握设备的技术状态，并提示应优先检修的对象。',
          points: [
            '与电网模型关联的设备状态监测',
            '状态分析与评估——改造和技术升级计划的依据',
            '算法按缺陷严重程度和设备重要性进行排序',
            '附带所需资源的最优检修计划',
            '投资计划编制大大加快：设备已按优先级排好序',
          ],
        },
        {
          id: 'grid-works',
          tab: '检修与并网',
          title: '现场作业管理',
          lead: '系统跟踪检修与新用户并网的进度，调度员随时掌握每个班组的位置。',
          points: [
            '检修计划：计划性检修、状态检修或二者结合',
            '各类作业的工时和人员定额已内置于系统中',
            '依据现行定额标准估算所需资源',
            '并网所需数据收集更快，用户可以更早接入电网',
          ],
        },
      ],
      results: [
        { title: '数据实时', text: '电网变化在作业完成后立即反映——企业信息始终最新' },
        { title: '信息受保护', text: '全面实施后，电网数据无法被篡改、删除或隐瞒；访问按角色授权' },
        { title: '固定费用', text: '许可费用与工位数量无关' },
        { title: '任意设备', text: '基于浏览器——办公室、调度室和现场均可使用' },
        { title: '降低对个人的依赖', text: '电网知识保存在系统中，而不是少数人的脑子里；界面经过简短培训即可上手' },
        { title: '灵活扩展', text: '适配不同设备，并可通过新模块持续扩展' },
      ],
    },
    {
      id: 'panel',
      sector: '能源 · 工程配置器',
      title: '一座变电站连同全套文档——10 分钟完成',
      lead: '为一家大型能源企业打造的 Web 系统：可完整计算各主要类型的箱式变电站以及低压成套配电设备，并生成技术与商务文档。工程师或销售人员只需描述需求，系统即给出最优方案，并为各部门准备好相应文件。',
      before: '布置方案、外观、设备选型、规格清单和预算全靠手工完成——每个项目要花几个小时甚至几天。需求稍有变动，就得从头重算。',
      after: '输入需求，10 分钟内即可得到最优方案和全套文档。需求变更时，系统只重新计算受影响的部分。',
      metrics: [
        { value: '≤10 分钟', label: '完成变电站计算与全套文档' },
        { value: '10+', label: '份文档/项目——自动生成' },
        { value: '3 个部门', label: '各得其所：销售、采购、生产' },
        { value: '0', label: '不兼容方案——系统不会放行' },
      ],
      modules: [
        {
          id: 'panel-spec',
          tab: '技术要求',
          title: '在线填写技术要求',
          lead: '所有关键要求都在一张表单中填写，随时可以调整——方案即时更新。',
          points: [
            '选型逻辑综合考虑技术要求、厂商目录、使用手册和标准',
            '智能提示简化选型，不兼容的方案根本无法选择',
            '厂商目录数据已预置在系统中',
            '需求变更时只需调整受影响的参数，其余由系统自动重算',
          ],
        },
        {
          id: 'panel-scheme',
          tab: '单线图与布置',
          title: '单线图和外观——自动生成',
          lead: '交互式编辑器，内置功能单元库，可自动计算装置参数。',
          points: [
            '基于功能单元库绘制单线图',
            '自动计算装置参数',
            '按比例显示外观和尺寸——客户在生产前就能看到成品',
            '统一的设计方法，无论由哪位工程师负责',
          ],
        },
        {
          id: 'panel-docs',
          tab: '文档',
          title: '为每个部门生成专属文档包',
          lead: '文档自动生成、在线编辑，并在相关部门之间完成审批和登记。',
          points: [
            '销售：单线图、外观图、供货合同及其规格附件、付款发票、商务报价',
            '采购：设备、材料、物流、人工及间接费用规格清单',
            '装配车间：外观图、单线图、规格清单和装配图',
            '可导出 PDF、XLS 和 DXF',
          ],
        },
        {
          id: 'panel-bom',
          tab: '预算与配置',
          title: '透明的预算，按厂商定制',
          lead: '每个柜体、模块和元件都标有价格：管理层清楚看到项目成本的构成。',
          points: [
            '按柜体、模块和元件自动生成含价格的规格清单',
            '为管理层提供透明的项目核算',
            '可针对特定厂商和企业进行通用配置',
            '可与其他软件系统和信息系统集成',
          ],
        },
      ],
      results: [
        { title: '几分钟出报价', text: '客户能快速获得完整的技术与商务信息' },
        { title: '错误更少', text: '不兼容的设备无法被选中' },
        { title: '告别重复劳动', text: '员工不再需要手工布置、选型和计算' },
        { title: '全程透明', text: '管理层可以看到完整的项目核算' },
        { title: '生产前可视化', text: '提前按比例看到外观和尺寸' },
        { title: '统一标准', text: '每个项目都遵循同一套方法，无论由谁负责' },
      ],
    },
  ],
  ui: {
    erp: { columns: ['询价', '核价中', '报价就绪', '已发客户'], modules: ['采购', '付款', '物流', '报关'], search: '按料号或品牌搜索', qty: '件' },
    portal: { search: '料号', qty: '数量', find: '搜索', supplier: '供应商', stock: '库存', lead: '交期', price: '单价, $', total: '金额, $', best: '最优', weeks: '周', suppliers: ['分销商 · 亚洲', '仓库 · 欧洲', '认证卖家', '授权分销商'] },
    catalog: { query: '功率电感', section: '功率电感器', positions: '约 12 万商品', filters: '筛选', apply: '应用', relevance: '相关度', partNumber: '料号', maker: '制造商', median: '中位价', inStock: '6 家供应商有货', demand: '需求', analogs: '替代料', datasheet: '数据手册', offers: '实时报价', trend: '3 个月' },
    search: { title: 'AI 搜索', rows: ['RX-485LV8 600', '电阻 4.7 kΩ 0603 5% 50', 'DX-2140S 150', '电容 22 µF 16 V X5R 0805 2000', '一行看不懂的文字'], exact: '精确料号', byParams: '按参数 · 5 个选项', analog: '替代料', unknown: '明确此行', counter: '2 个料号 · 3 条描述', file: 'spec.pdf', fileResult: '64 行 → 11 条，剔除 53 行', find: '搜索', toCart: '加入购物车' },
    agent: {
      title: '客户的 AI 助手 · MCP',
      user1: '帮我找 DX-2140S，需要 2000 个',
      tool1: 'search_partnumber',
      agent1: '找到 12 家供应商的约 310 条报价。库存约 900 万个，最快 5 天到货。',
      user2: '选一个 14 天内到货、价格最低的方案',
      tool2: 'get_best_offer',
      agent2: '2000 个，单价 $0.006，合计 $12.00，6 天到货，免运费。',
      confirm: '要下单吗？',
      user3: '好的，下单并把发票发给我',
      tool3: 'create_order · get_invoice',
      agent3: '已以贵公司名义下单。发票见附件。',
      invoice: '发票.pdf',
      typing: '智能体正在与商城交互…',
    },
    grid: { editor: '编辑器', scheme: '电网图', layers: ['线路编辑', '变电站', '杆塔', '用户', '监测'], legend: ['110 kV', '10 kV', '0.4 kV'], substation: '变电站-12 · 10/0.4 kV', search: '地址或设施' },
    panel: { units: '功能单元', settings: '参数', params: [['电压', '380 V'], ['频率', '50 Hz'], ['母线电流', '630 A'], ['防护等级', 'IP42'], ['备用', '10 %']], front: '正视图', export: '导出', feeder: '出线' },
    tower: { title: '14 号杆塔 · 10 kV 线路', photo: '照片 · 3', rows: [['材质', '钢筋混凝土'], ['用途', '直线杆'], ['结构', '单杆'], ['线路', '10 kV L-2 · 0.4 kV L-5'], ['状态', '良好']], history: '历史', events: [['08/12', '巡检 · 接地测量'], ['06/03', '更换绝缘子'], ['04/19', '建档 · 拍照']], add: '派发工单' },
    monitor: { title: '缺陷排序', cols: ['对象', '缺陷', '严重程度', '检修'], rows: [['变电站-12', '触点过热', 92, '第 38 周'], ['10 kV L-3', '杆塔倾斜', 78, '第 40 周'], ['0.4 kV C-7', '绝缘下降', 64, '第 43 周'], ['变电站-5', '漏油', 41, '第四季度']], schedule: '检修计划', weeks: ['38', '39', '40', '41', '42', '43'], resources: '资源', crew: '2 个班组 · 46 工时' },
    works: { title: '工单', columns: ['计划', '进行中', '已完成'], items: [['用户并网 · 150 kW', '变电站-9', 0], ['更换 31 号杆塔', '10 kV L-4', 0], ['检修变电站-12', '状态检修', 1], ['巡检 0.4 kV L-5', '计划检修', 1], ['负荷测量 变电站-3', '计划检修', 2], ['更换绝缘子', '10 kV L-2', 2]], crew: '3 号班组', crewStatus: '在现场 · 变电站-12', connection: '用户并网' },
    spec: { title: '技术要求 · 项目 2417', fields: [['变电站类型', '箱式变电站'], ['变压器', '2 × 1000 kVA'], ['高压 / 低压', '10 / 0.4 kV'], ['高压开关柜', '单母线'], ['低压出线', '12'], ['低压母线电流', '1600 A'], ['型式', '保温型']], warning: '630 A 进线断路器与 1600 A 母线不兼容', fix: '替换为 1600 A', recalc: '已重新计算：单线图、规格清单、预算', build: '生成文档' },
    docs: { departments: ['销售部', '采购部', '装配车间'], items: [['单线图', '外观图', '供货合同', '合同规格附件', '付款发票', '商务报价'], ['设备规格清单', '材料规格清单', '物流规格清单', '人工与间接费用'], ['外观图', '单线图', '设备规格清单', '材料规格清单', '装配图']], approved: '已批准', editing: '审批中' },
    bom: { title: '规格清单与预算', cols: ['柜体', '模块', '元件', '价格'], rows: [['1 号柜 · 进线', 'QF-2 · ACB', '1600 A 断路器', '20 150'], ['2 号柜 · 母联', 'QF-6.1 · ACB', '630 A 断路器', '11 010'], ['3 号柜 · 出线', 'QF-6.2 · MCCB × 6', '250 A 断路器', '4 860'], ['4 号柜 · 计量', 'PM-1 · 计量', '电表、互感器', '2 150'], ['5 号柜 · 自投', 'ATS-1', '自动切换控制器', '1 680']], total: '项目合计', totalValue: '39 850', maker: '制造商：可配置' },
  },
}
